import { render } from "./GroupsSelect.vue?vue&type=template&id=6480e916&scoped=true"
import script from "./GroupsSelect.vue?vue&type=script&lang=js"
export * from "./GroupsSelect.vue?vue&type=script&lang=js"

import "./GroupsSelect.vue?vue&type=style&index=0&id=6480e916&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6480e916"]])

export default __exports__